const groupPrefix = createApiRoute(
	ApiModule.DIETARY,
	ApiDataModel.PRODUCTION_MACHINES,
	ApiDataModel.PRODUCTION_MACHINE_TYPES,
)

export const apiProductionMachineTypes = {
	fetchProductionMachineTypes: async (): Promise<IApiResponseModel<IProductionMachineTypeModel[]>> => {
		const { data } = await apiCommon<IProductionMachineType[]>(`${groupPrefix}`, { method: 'GET' })

		return { data: data.map(ProductionMachineType) }
	},
	createProductionMachineType: async (
		payload: IProductionMachineTypeCreatePayload,
	): Promise<IProductionMachineTypeModel> => {
		const { data } = await apiCommon<IProductionMachineType>(`${groupPrefix}`, { method: 'POST', body: payload })

		return ProductionMachineType(data)
	},
	updateProductionMachineType: async (
		payload: IProductionMachineTypeUpdatePayload,
	): Promise<IProductionMachineTypeModel> => {
		const { data } = await apiCommon<IProductionMachineType>(`${groupPrefix}/${payload.id}`, {
			method: 'PUT',
			body: payload,
		})

		return ProductionMachineType(data)
	},
}
